var utils = require('./extrax2-webadmin.utils.js');
var validator = require('./extrax2-webadmin.validator.js');
var ajax = require('./extrax2-webadmin.ajax.js');

function initializeElements(element) {

	// Summernote Editor (muss vor den Tooltips erfolgen)
	initializeSummernote($(element).find('.summernote:not(.summernote-container)'));

	$(element).find('.tooltips').tooltip();

	$('.draggable-modal').draggable({
		handle: '.modal-header'
	});

	var handle_ajax_error = function (error) {
		if (error.status == "401") {
			location.reload();
		} else {
			utils.setHtmlData($("#content"), error.responseText, false);
		}
	};

	$(element).find('.tt-copy-values:not(.tt-copy-values-container)').each(function () {

		var clipboard = new ClipboardJS(this);
		toastr.options = {
			"closeButton": false,
			"debug": false,
			"positionClass": "toast-top-right",
			"onclick": null,
			"showDuration": "1000",
			"hideDuration": "1000",
			"timeOut": "3000",
			"extendedTimeOut": "1000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		}

		clipboard.on('success', function(e) {
			toastr.success(trans('extrax2-webadmin.serial_numbers_copied_to_clipboard'));
		});
		clipboard.on('error', function(e) {
			console.error(e);
			toastr.error(trans('extrax2-webadmin.serial_numbers_copied_to_clipboard_failed'));
		});

		$(this).addClass("tt-copy-values-container");
	});

	initializeDatepicker($(element).find('.datepicker:not(.datepicker-container)'));

	$(element).find('.timepicker:not(.timepicker-container)').each(function () {

		var showSeconds = true;
		if (!utils.isUndefined($(this).data().showSeconds))
		{
			showSeconds = $(this).data().showSeconds;
		}
		$(this).mask('?' + $(this).data().mask, { placeholder: '_' });

		$(this).timepicker({
			minuteStep: 1,
			showMeridian: false,
			defaultTime: false,
			showSeconds: showSeconds
		});

		$(this).addClass("timepicker-container");
	});

	$(element).find('.tt-datatable:not(.datatable-container)').each(function () {

		var element = $(this);

		var dom = "t";
		var scroll = "";
		var sort = true;
		var orderType = "asc";
		if (!utils.isUndefined(element[0].getAttribute('data-table-default-order-type'))) {
			orderType = element[0].getAttribute('data-table-default-order-type');
		}

		var zeroRecordsText = Lang.get('extrax2-webadmin.no_data_found');
		if (!utils.isUndefined(element[0].getAttribute('data-table-zero-records-text'))) {
			zeroRecordsText = element[0].getAttribute('data-table-zero-records-text');
		}

		var ajax_url = $(this)[0].getAttribute('data-table-url') + "/datatable";

		var doInitializeElements = true;

		var columnDefinitions = [
			{
				targets: [0],
				visible: false,
				searchable: false
			}
		];

		if (element[0].id === "table_users") {
			columnDefinitions = [
				{
					targets: [0, 1],
					visible: false,
					searchable: false
				},
				{
					targets: [2],
					render: function (data, type, full, meta) {
						if (full[8] === 1 || full[8] === "1") {
							return data + '&nbsp;&nbsp;<i class="icon-lock"></i>';
						}
						return data;
					}
				},
				{
					targets: [7],
					searchable: false
				}
			];
		} else if (element[0].id === "table_projects") {
			columnDefinitions = [
				{
					targets: [0, 7],
					visible: false,
					searchable: false
				},
				{
					targets: [1],
					render: function (data, type, full, meta) {
						if (full[8] === 1 || full[8] === "1") {
							return data + '&nbsp;&nbsp;<i class="icon-lock"></i>';
						}
						return data;
					}
				},
				{
					targets: [3],
					render: function (data, type, full, meta) {
						if (type === 'display') {
							return Lang.get('extrax2-webadmin.' + data);
						}
						return data;
					}
				},
				{
					targets: [4, 5, 6],
					render: function (data, type, full, meta) {
						if (data === 1 || data === '1') {
							return '<div class="md-checkbox">' +
								'<input class="md-check" type="checkbox" checked="checked" disabled="disabled">' +
								'<label>' +
								'<span></span>' +
								'<span class="check"></span>' +
								'<span class="box"></span></label>' +
								'</div>';
						}
						return '';
					}
				}
			];
		} else if (element[0].id === "table_participants") {
			if (element.data().fixedAccounting) {
				columnDefinitions = [
					{
						targets: [0],
						visible: false,
						searchable: false
					},
					{
						targets: [1],
						render: function (data, type, full, meta) {
							if (full[4] === 1 || full[4] === "1") {
								return full[0] + ' - ' + data + '&nbsp;&nbsp;<i class="icon-lock"></i>';
							}
							return full[0] + ' - ' + data;
						}
					},
					{
						targets: [3],
						render: function (data, type, full, meta) {
							var returnString = '';
							if (!utils.isUndefined(data) && data !== '') {
								returnString += data;
							}
							returnString += '&nbsp;/&nbsp;';
							if (!utils.isUndefined(full[5]) && full[5] !== '') {
								returnString += full[5];
							}
							return returnString;
						},
						searchable: false
					}
				];
			} else if (element.data().projectType === 'tripletrax') {
				columnDefinitions = [
					{
						targets: [0],
						visible: false,
						searchable: false
					},
					{
						targets:[1],
						render: function (data, type, full, meta) {
							if (full[6] === 1 || full[6] === "1") {
								return full[0] + ' - ' + data + '&nbsp;&nbsp;<i class="icon-lock"></i>';
							}
							return full[0] + ' - ' + data;
						}
					},
					{
						targets: [2, 3],
						searchable: false,
						render: function (data, type, full, meta) {
							if (full.length > 4) {
								return utils.dateToLocaleString(data);
							}
							return data;
						}
					}
				];
			} else {
				columnDefinitions = [
					{
						targets: [0],
						visible: false,
						searchable: false
					},
					{
						targets:[1],
						render: function (data, type, full, meta) {
							if (full[6] === 1 || full[6] === "1") {
								return full[0] + ' - ' + data + '&nbsp;&nbsp;<i class="icon-lock"></i>';
							}
							return full[0] + ' - ' + data;
						}
					},
					{
						targets: [2, 3],
						searchable: false,
						render: function (data, type, full, meta) {
							if (full.length > 4) {
								return utils.dateToLocaleString(data);
							}
							return data;
						}
					},
					{
						targets: [5],
						render: function (data, type, full, meta) {
							var returnString = '';
							if (!utils.isUndefined(data) && data !== '')
							{
								returnString += data;
							}
							returnString += '&nbsp;/&nbsp;';
							if (!utils.isUndefined(full[7]) && full[7] !== '')
							{
								returnString += full[7];
							}
							return returnString;
						},
						searchable: false
					},
					{
						targets: [6, 7],
						visible: false,
						searchable: false
					},
					{
						targets: [8, 9],
						visible: false,
						searchable: true
					}
				];
			}
		} else if (element[0].id === "table_software_versions") {
			columnDefinitions = [
				{
					targets: [0, 8, 9],
					visible: false,
					searchable: false
				},
				{
					targets: [1],
					orderData: [8, 9]
				},
				{
					targets: [3, 4, 5, 6],
					render: function (data, type, full, meta) {
						if (data === 1 || data === '1') {
							return '<div class="md-checkbox">' +
								'<input class="md-check" type="checkbox" checked="checked" disabled="disabled">' +
								'<label>' +
								'<span></span>' +
								'<span class="check"></span>' +
								'<span class="box"></span></label>' +
								'</div>';
						}
						return '';
					}
				}
			];
		} else if (element[0].id === "table_email_recipients") {
			columnDefinitions = [
				{
					targets: [0, 4, 5, 6, 7, 8],
					visible: false,
					searchable: false
				},
				{
					targets: [2],
					render: function (data, type, full, meta) {
						if (full[6] === 1 || full[6] === '1') {
							return trans('extrax2-webadmin.active_participants');
						}
						else if (full[7] === '1' || full[7] === 1) {
							return data + ' (' + trans('extrax2-webadmin.project_partner_contact1') + ')';
						}
						else if (full[8] === '1' || full[8] === 1) {
							return data + ' (' + trans('extrax2-webadmin.project_partner_contact2') + ')';
						}
						else if (full[4] !== null && full[4] !== '') {
							return data + ' (' + trans('extrax2-webadmin.project_partner') + ')';
						}
						else if (full[5] !== null && full[5] !== '') {
							return data + ' (' + trans('extrax2-webadmin.user') + ')';
						}
						return data;
					}
				},
				{
					targets: [3],
					render: function (data, type, full, meta) {
						if (data === '1' || data === 1) {
							return '<div class="md-checkbox">' +
								'<input class="md-check" type="checkbox" checked="checked" disabled="disabled">' +
								'<label>' +
								'<span></span>' +
								'<span class="check"></span>' +
								'<span class="box"></span></label>' +
								'</div>';
						}
						return '';
					}
				}
			];
		} else if (element[0].id === "table_request_history") {
			columnDefinitions = [
				{
					targets: [0],
					visible: false,
					searchable: false
				},
				{
					targets: [1],
					render: function (data, type, full, meta) {
						if (type === 'display' && data) {
							return '<strong>' + utils.dateToLocaleTimeString(data, false) + '</strong>';
						}
						return data;
					}
				},
				{
					targets: [3],
					render: function (data, type, full, meta) {
						if (type === 'display' && data && data.length) {
							try {
								var jsonData = jQuery.parseJSON(data);
								var stringData = '';
								$.each(jsonData, function (i, item) {
									if (stringData.length) {
										stringData += '<br>';
									}
									stringData += i + ': ' + decodeURI(item);
								});
								return stringData;
							} catch (e) {
								return data.replace(/,/g, ', ');
							}
						}
						return data;
					}
				},
				{
					targets: [7, 8],
					render: function (data, type, full, meta) {
						if (type === 'display' && data) {
							return data.replace(/,/g, ', ');
						}
						return data;
					}
				}
			];
		} else if (element[0].id === "table_account_draw_up") {
			columnDefinitions = [
				{
					targets: [0],
					visible: false,
					searchable: false
				},
				{
					targets: [1],
					render: function (data, type, full, meta) {
						return '<div class="md-checkbox">' +
							'<input class="md-check" type="checkbox">' +
							'<label>' +
							'<span></span>' +
							'<span class="check"></span>' +
							'<span class="box"></span></label>' +
							'</div>';
					}
				}
			];
		} else if (element[0].id === "table_account_draw_up_history") {
			columnDefinitions = [
				{
					targets: [0],
					visible: false,
					searchable: false
				},
				{
					targets: [1],
					render: function (data, type, full, meta) {
						if (type === 'display') {
							return utils.dateToLocaleTimeString(data, false);
						}
						return data;
					}
				},
				{
					targets: [2],
					render: function (data, type, full, meta) {
						if (type === 'display') {
							return utils.dateToLocaleString(data);
						}
						return data;
					}
				}
			];
		} else if (element[0].id === 'table_reminders') {
			columnDefinitions = [
				{
					targets: [0],
					visible: false,
					searchable: false
				},
				{
					targets: [1, 2],
					render: function (data, type, full, meta) {
						if (type === 'display') {
							return trans('extrax2-webadmin.' + data);
						}

						return data;
					}
				},
				{
					targets: [3],
					render: function (data, type, full, meta) {
						if (data === 'monthly') {
							if (full[11] === 'all') {
								if (full[14] !== '') {
									var day = full[14] + '.';
									if (day === 'last.') {
										day = Lang.get('extrax2-webadmin.last');
									}
									return Lang.get('extrax2-webadmin.text_repeat_monthly_all_months_on_day', {'day': day, 'time': full[15]});
								} else {
									return Lang.get('extrax2-webadmin.text_monthly_all_months_on_day_of_the_week', {'day': Lang.get('extrax2-webadmin.' + full[10]), 'weekday': Lang.get('extrax2-webadmin.' + full[9]), 'time': full[15]});
								}
							} else {
								var months = '';
								var monthArray = full[11].split('|');
								$.each(monthArray, function(i, element) {
									if (months !== '' && i !== monthArray.length - 1) {
										months += ', ';
									} else if (months !== '' && i === monthArray.length - 1) {
										months += ' ' + Lang.get('extrax2-webadmin.and') + ' ';
									}
									months += Lang.get('extrax2-webadmin.' + element);
								});

								if (full[14] !== '') {
									var day = full[14] + '.';
									if (day === 'last.') {
										day = Lang.get('extrax2-webadmin.last');
									}
									return Lang.get('extrax2-webadmin.text_repeat_monthly_on_day', {'day': day, 'time': full[15], 'months': months});
								} else {
									return Lang.get('extrax2-webadmin.text_monthly_on_day_of_the_week', {'day': Lang.get('extrax2-webadmin.' + full[10]), 'weekday': Lang.get('extrax2-webadmin.' + full[9]), 'time': full[15], 'months': months});
								}
							}
						} else if (data === 'weekly') {
							var days = '';
							var dayArray = full[8].split('|');
							$.each(dayArray, function(i, element) {
								if (days !== '' && i !== dayArray.length - 1) {
									days += ', ';
								} else if (days !== '' && i === dayArray.length - 1) {
									days += ' ' + Lang.get('extrax2-webadmin.and') + ' ';
								}
								days += Lang.get('extrax2-webadmin.' + element);
							});

							if (full[13] === '1' || full[13] === 1) {
								return Lang.get('extrax2-webadmin.text_weekly_all_weeks', {'day': day, 'time': full[15], 'selection_days': days});
							} else {
								return Lang.get('extrax2-webadmin.text_weekly', {'week': full[13] + '.', 'day': day, 'time': full[15], 'selection_days': days});
							}
						} else if (data === 'daily') {
							if (full[12] === '1' || full[12] === 1) {
								return Lang.get('extrax2-webadmin.text_daily_all_days', {'time': full[15]});
							} else {
								return Lang.get('extrax2-webadmin.text_daily', {'day': full[12] + '.', 'time': full[15]});
							}
						}


						return data;
					}
				},
				{
					targets: [5],
					render: function (data, type, full, meta) {
						if (type === 'display' && full[17] !== null) {
							return full[19] + ' ' + full[18];
						}

						return data;
					}
				},
				{
					targets: [6],
					render: function (data, type, full, meta) {
						if (type === 'display' && full[16]) {
							return trans('extrax2-webadmin.participant');
						}

						return data;
					}
				}
			];
		}

		$(this).on('processing.dt', function (e, settings, processing) {
			if (processing) {
				App.blockUI({
					target: 'body',
					animate: true
				});
			} else {
				App.unblockUI('body');
			}
		}).dataTable({
			processing: true,
			serverSide: true,
			paging: true,
			sort: sort,
			scrollY: scroll,
			scroller: {
				loadingIndicator: true
			},
			info: true,
			autoWidth: false,
			deferRender: true,
			pageLength: parseInt($(this)[0].getAttribute('data-table-page-length')),
			order: [[parseInt($(this)[0].getAttribute('data-table-default-order-column')), orderType]],
			language: {
				zeroRecords: zeroRecordsText,
				processing: ''
			},
			dom: dom,
			columnDefs: columnDefinitions,
			ajax: {
				url: ajax_url,
				error: handle_ajax_error,
				data: function (d) {
					if (element[0].id === "table_participants") {
						if(!utils.isUndefined(utils.GLOBALS.participantToShow) && utils.GLOBALS.participantToShow !== ''){
							return $.extend({}, d, {
								'participant_id': utils.GLOBALS.participantToShow
							});
						}
						else if ((!(isNaN($('.tt-datatable-search').val().replace(/"/g, '\\b')))) && $('.tt-datatable-search').val() !== ''){
							return $.extend({}, d, {
								'numeric_search_term': $('.tt-datatable-search').val().replace(/"/g, '\\b')
							});
						}
					} else if (element[0].id === "table_request_history") {
						var picker = null;
						var fromVal = jQuery($('#from_date')).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '');
						if (fromVal !== '') {
							picker = $('#from_date').data('picker');
							fromVal = utils.dateToString(picker.getDate());
						}
						var tillVal = jQuery($('#till_date')).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '');
						if (tillVal !== '') {
							picker = $('#till_date').data('picker');
							tillVal = utils.dateToString(picker.getDate());
						}
						var searchText = $('.tt-datatable-search').val();
						return $.extend({}, d, {
							'from_date': fromVal,
							'till_date': tillVal,
							'search_text' : searchText
						});
					}
					return d;
				}
			},
			drawCallback: function (settings) {
				setPaginateButtons($(this), settings, false);
			},
			rowCallback: function (row, data, displayIndex) {
				row.id = data[0];

				if (row.id == $('#content-detail').find('.tt-selected-id').val()) {
					$(row).addClass('active');
				}
				if ($(this)[0].id === "table_users" || $(this)[0].id === "table_projects") {
					if (data[8] === 1 || data[8] === "1") {
						$('td', row).addClass('locked');
					}
				} else if ($(this)[0].id === "table_participants") {
					if (data.length > 4 && data[3] !== null && utils.stringToDate(data[3]) < (new Date())) {
						$('td', row).addClass('locked');
					}
					if ((data.length == 7 && (data[6] === 1 || data[6] === '1')) || (data.length == 5 && (data[4] === 1 || data[4] === '1'))) {
						$('td', row).addClass('locked');
					}
				} else if (element[0].id === 'table_request_history') {
					$('td:nth-child(3)', row).addClass('request-history-column');
				}
			},
			initComplete: function (settings, json) {

				$(this).addClass("datatable-container");

				if (element[0].id === "table_participants") {

					// Wenn ein Teilnehmer direkt ausgewählt werden soll, aktuellen Teilnehmer in der Liste auswählen
					if (!utils.isUndefined(utils.GLOBALS.participantToShow) && utils.GLOBALS.participantToShow !== '') {

						$('#table_participants').find('tr[id="' + utils.GLOBALS.participantToShow + '"]').addClass('active');
						$('#table_participants').find('tr[id="' + utils.GLOBALS.participantToShow + '"]').find('td')[0].click();

						utils.updateGlobals('participantToShow', null);
					}
				}
			}
		});
	});

	$(element).find('.tt-datatable-detail:not(.datatable-container),.tt-datatable-dialog:not(.datatable-container)').each(function () {

		var element = $(this);

		var sort = true;
		if ($(element[0]).hasClass('tt-not-sortable')) {
			sort = false;
		}

		var orderType = "asc";
		if (!utils.isUndefined(element[0].getAttribute('data-table-default-order-type'))) {
			orderType = element[0].getAttribute('data-table-default-order-type');
		}

		var scroll = "";
		if (!utils.isUndefined(element[0].getAttribute('data-table-scroll'))) {
			scroll = parseInt($(this)[0].getAttribute('data-table-scroll'));
		}

		var paging = true;

		var columns = [

		];

		if (element[0].id === "table_error_report" || element[0].id === "table_error_report_global") {
			columns = [
				{
					targets: [0],
					visible: false,
					searchable: false
				},
				{
					targets: [1],
					render: function (data, type, full, meta) {
						if (type === 'display') {
							return '<strong>' + utils.dateToLocaleTimeString(data, false) + '</strong>';
						}
						return data;
					}
				},
				{
					targets: [2],
					render: function (data, type, full, meta) {
						if (type === 'display') {
							if (data === 'D') {
								return trans('extrax2-webadmin.debug');
							} else if (data === 'I') {
								return trans('extrax2-webadmin.information');
							} else if (data === 'W') {
								return trans('extrax2-webadmin.warning');
							} else if (data === 'E') {
								return trans('extrax2-webadmin.error');
							} else if (data === 'C') {
								return trans('extrax2-webadmin.critical_error');
							}
							return data;
						}
						return data;
					}
				},
				{
					targets: [3],
					render: function (data, type, full, meta) {
						if (type === 'display') {
							if (data === 'i') {
								return trans('extrax2-webadmin.internal');
							} else if (data === 'ec') {
								return trans('extrax2-webadmin.external_cache');
							} else if (data === 'dc') {
								return trans('extrax2-webadmin.file_cache');
							} else if (data === 'bc') {
								return trans('extrax2-webadmin.bsnr_cache');
							} else if (data === 'tc') {
								return trans('extrax2-webadmin.text_cache');
							} else if (data === 'xx') {
								return trans('extrax2-webadmin.extrax');
							} else if (data === 'dl') {
								return trans('extrax2-webadmin.extrax_dll');
							} else if (data === 'xh') {
								return trans('extrax2-webadmin.automation_service');
							}
							return data;
						}
						return data;
					}
				}
			];
		}

		var dataTable = $(this).dataTable({
			processing: false,
			serverSide: false,
			paging: paging,
			info: true,
			autoWidth: false,
			sort: sort,
			scrollY: scroll,
			pageLength: parseInt($(this)[0].getAttribute('data-table-page-length')),
			order: [[parseInt($(this)[0].getAttribute('data-table-default-order-column')), orderType]],
			language: {
				zeroRecords: Lang.get('extrax2-webadmin.no_data_found')
			},
			dom: 't',
			columnDefs: columns,
			drawCallback: function (settings) {
				if (paging) {
					setPaginateButtons($(this), settings, false);
				}
			},
			rowCallback: function (row, data, displayIndex) {
				row.id = data[0];

				if ($(this)[0].id === "table_error_report" || $(this)[0].id === "table_error_report_global") {
					if (data[2] === 'I') {
						// $(row).addClass('success');
					} else if (data[2] === 'W') {
						$(row).addClass('warning');
					} else if (data[2] === 'E') {
						$(row).addClass('danger');
					} else if (data[2] === 'C') {
						$(row).addClass('critical_danger');
					}
				}
			},
			initComplete: function (settings, json) {
				$(this).addClass("datatable-container");
			}
		});
	});

	$(element).find('.tt-datatable-data:not(.datatable-container)').each(function () {

		var element = $(this);

		var dom = "t";
		var scroll = "";
		var data = null;
		var paging = true;
		var sort = true;
		var orderType = "asc";
		if (!utils.isUndefined(element[0].getAttribute('data-table-default-order-type'))) {
			orderType = element[0].getAttribute('data-table-default-order-type');
		}

		var emptyTableText = Lang.get('extrax2-webadmin.no_data_found');
		var zeroRecordsText = Lang.get('extrax2-webadmin.no_data_found');
		if (!utils.isUndefined(element[0].getAttribute('data-table-empty-table-text'))) {
			emptyTableText = element[0].getAttribute('data-table-empty-table-text');
		}
		if (!utils.isUndefined(element[0].getAttribute('data-table-zero-records-text'))) {
			zeroRecordsText = element[0].getAttribute('data-table-zero-records-text');
		}

		var columnDefinitions = [
			{
				data: 'id',
				targets: 0,
				visible: false,
				searchable: false
			}
		];

		if (element[0].id === 'table_account_draw_up') {
			if (element.data().historyId > 0) {
				if (element.data().fixedAccounting) {
					columnDefinitions = [
						{
							data: 'id',
							targets: [0],
							visible: false,
							searchable: false
						},
						{
							data: 'selection',
							targets: [1],
							searchable: false,
							orderable: false,
							render: function (data, type, full, meta) {
								if (type === 'display') {
									return '<div class="md-checkbox-list">' +
										'<div class="md-checkbox">' +
										'<input class="md-check tt-list-check tt-check-all" type="checkbox" name="checkbox_' + full['consecutive_number'] + '" value="' + full['consecutive_number'] + '" checked>' +
										'<label>' +
										'<span></span>' +
										'<span class="check"></span>' +
										'<span class="box"></span></label>' +
										'</div>' +
										'</div>';
								}
							}
						},
						{
							data: 'consecutive_number',
							targets: [2]
						},
						{
							data: 'accounting_period',
							targets: [3],
							render: function (data, type, full, meta) {
								if (data === 'one_time_usage') {
									return trans('extrax2-webadmin.' + data);
								}
								var periodArray = data.split('#');
								return utils.dateToLocaleString(periodArray[0]) + ' - ' + utils.dateToLocaleString(periodArray[1]);
							}
						},
						{
							data: 'maturity_date',
							targets: [4],
							render: function (data, type, full, meta) {
								return utils.dateToLocaleString(data);
							}
						},
						{
							data: 'doctor_name',
							targets: [5]
						},
						{
							data: 'customer_id_lexware',
							targets: [6]
						},
						{
							data: 'payment',
							targets: [7],
							render: function (data, type, full, meta) {
								if (data !== '') {
									return trans('extrax2-webadmin.' + data);
								}
								return data;
							}
						},
						{
							data: 'amount',
							targets: [8],
							render: function (data, type, full, meta) {
								if (!utils.isUndefined(full['same_professional_group']) && full['same_professional_group']) {
									return '* ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['same_lanr']) && full['same_lanr']) {
									return '** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['same_bsnr']) && full['same_bsnr']) {
									return '*** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['same_account_id']) && full['same_account_id']) {
									return '**** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['developer_license']) && full['developer_license']) {
									return '***** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['voucher_code']) && full['voucher_code'].length) {
									return '****** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['no_usage']) && full['no_usage']) {
									return '******* ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['free_of_charge']) && full['free_of_charge']) {
									return '******** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['already_accounted']) && full['already_accounted']) {
									return '********* ' + utils.getLocaleNumberFromString(data, 2);
								}
								return utils.getLocaleNumberFromString(data, 2);
							}
						},
						{
							data: 'error',
							targets: [9],
							visible: false
						}
					];
				} else {
					columnDefinitions = [
						{
							data: 'id',
							targets: [0],
							visible: false,
							searchable: false
						},
						{
							data: 'selection',
							targets: [1],
							searchable: false,
							orderable: false,
							className: 'select-checkbox',
							render: function (data, type, full, meta) {
								if (type === 'display') {
									var isChecked = '';
									if (data) {
										isChecked = ' checked';
									}

									return '<div class="md-checkbox-list">' +
										'<div class="md-checkbox tt-list-checkbox">' +
										'<input class="md-check tt-list-selection" type="checkbox" id="checkbox_' + full['consecutive_number'] + '" name="checkbox_' + full['consecutive_number'] + '">' +
										'<label for="checkbox_' + full['consecutive_number'] + '">' +
										'<span></span>' +
										'<span class="check"></span>' +
										'<span class="box"></span></label>' +
										'</div>' +
										'</div>';
								}
								return data;
							}
						},
						{
							data: 'consecutive_number',
							targets: [2]
						},
						{
							data: 'accounting_period',
							targets: [3],
							render: function (data, type, full, meta) {
								if (data === 'one_time_usage') {
									return trans('extrax2-webadmin.' + data);
								}
								var periodArray = data.split('#');
								return utils.dateToLocaleString(periodArray[0]) + ' - ' + utils.dateToLocaleString(periodArray[1]);
							}
						},
						{
							data: 'maturity_date',
							targets: [4],
							render: function (data, type, full, meta) {
								return utils.dateToLocaleString(data);
							}
						},
						{
							data: 'doctor_name',
							targets: [5]
						},
						{
							data: 'invoice_recipient',
							targets: [6],
							render: function (data, type, full, meta) {
								if (!utils.isUndefined(full['voucher_code']) && full['voucher_code'].length) {
									return data + '<br>(Gutscheincode ' + full['voucher_code'] + ')'
								}
								return data;
							}
						},
						{
							data: 'customer_id_lexware',
							targets: [7]
						},
						{
							data: 'payment',
							targets: [8],
							render: function (data, type, full, meta) {
								if (data !== '') {
									return trans('extrax2-webadmin.' + data);
								}
								return data;
							}
						},
						{
							data: 'professional_group',
							targets: [9]
						},
						{
							data: 'bsnr',
							targets: [10]
						},
						{
							data: 'lanr',
							targets: [11]
						},
						{
							data: 'account_id',
							targets: [12]
						},
						{
							data: 'amount',
							targets: [13],
							render: function (data, type, full, meta) {
								if (!utils.isUndefined(full['same_professional_group']) && full['same_professional_group']) {
									return '* ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['same_lanr']) && full['same_lanr']) {
									return '** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['same_bsnr']) && full['same_bsnr']) {
									return '*** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['same_account_id']) && full['same_account_id']) {
									return '**** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['developer_license']) && full['developer_license']) {
									return '***** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['voucher_code']) && full['voucher_code'].length) {
									return '****** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['no_usage']) && full['no_usage']) {
									return '******* ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['free_of_charge']) && full['free_of_charge']) {
									return '******** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['already_accounted']) && full['already_accounted']) {
									return '********* ' + utils.getLocaleNumberFromString(data, 2);
								}
								return utils.getLocaleNumberFromString(data, 2);
							}
						},
						{
							data: 'error',
							targets: [14],
							visible: false
						}
					];
				}
			} else {
				if (element.data().fixedAccounting) {
					columnDefinitions = [
						{
							data: 'id',
							targets: [0],
							visible: false,
							searchable: false
						},
						{
							data: 'consecutive_number',
							targets: [1]
						},
						{
							data: 'accounting_period',
							targets: [2],
							render: function (data, type, full, meta) {
								if (data === 'one_time_usage') {
									return trans('extrax2-webadmin.' + data);
								}
								var periodArray = data.split('#');
								return utils.dateToLocaleString(periodArray[0]) + ' - ' + utils.dateToLocaleString(periodArray[1]);
							}
						},
						{
							data: 'maturity_date',
							targets: [3],
							render: function (data, type, full, meta) {
								return utils.dateToLocaleString(data);
							}
						},
						{
							data: 'doctor_name',
							targets: [4]
						},
						{
							data: 'customer_id_lexware',
							targets: [5]
						},
						{
							data: 'payment',
							targets: [6],
							render: function (data, type, full, meta) {
								if (data !== '') {
									return trans('extrax2-webadmin.' + data);
								}
								return data;
							}
						},
						{
							data: 'amount',
							targets: [7],
							render: function (data, type, full, meta) {
								if (!utils.isUndefined(full['same_professional_group']) && full['same_professional_group']) {
									return '* ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['same_lanr']) && full['same_lanr']) {
									return '** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['same_bsnr']) && full['same_bsnr']) {
									return '*** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['same_account_id']) && full['same_account_id']) {
									return '**** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['developer_license']) && full['developer_license']) {
									return '***** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['voucher_code']) && full['voucher_code'].length) {
									return '****** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['no_usage']) && full['no_usage']) {
									return '******* ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['free_of_charge']) && full['free_of_charge']) {
									return '******** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['already_accounted']) && full['already_accounted']) {
									return '********* ' + utils.getLocaleNumberFromString(data, 2);
								}
								return utils.getLocaleNumberFromString(data, 2);
							}
						},
						{
							data: 'error',
							targets: [8],
							visible: false
						}
					];
				} else {
					columnDefinitions = [
						{
							data: 'id',
							targets: [0],
							visible: false,
							searchable: false
						},
						{
							data: 'consecutive_number',
							targets: [1]
						},
						{
							data: 'accounting_period',
							targets: [2],
							render: function (data, type, full, meta) {
								if (data === 'one_time_usage') {
									return trans('extrax2-webadmin.' + data);
								}
								var periodArray = data.split('#');
								return utils.dateToLocaleString(periodArray[0]) + ' - ' + utils.dateToLocaleString(periodArray[1]);
							}
						},
						{
							data: 'maturity_date',
							targets: [3],
							render: function (data, type, full, meta) {
								return utils.dateToLocaleString(data);
							}
						},
						{
							data: 'doctor_name',
							targets: [4]
						},
						{
							data: 'invoice_recipient',
							targets: [5],
							render: function (data, type, full, meta) {
								if (!utils.isUndefined(full['voucher_code']) && full['voucher_code'].length) {
									return data + '<br>(Gutscheincode ' + full['voucher_code'] + ')'
								}
								return data;
							}
						},
						{
							data: 'customer_id_lexware',
							targets: [6]
						},
						{
							data: 'payment',
							targets: [7],
							render: function (data, type, full, meta) {
								if (data !== '') {
									return trans('extrax2-webadmin.' + data);
								}
								return data;
							}
						},
						{
							data: 'professional_group',
							targets: [8]
						},
						{
							data: 'bsnr',
							targets: [9]
						},
						{
							data: 'lanr',
							targets: [10]
						},
						{
							data: 'account_id',
							targets: [11]
						},
						{
							data: 'amount',
							targets: [12],
							render: function (data, type, full, meta) {
								if (!utils.isUndefined(full['same_professional_group']) && full['same_professional_group']) {
									return '* ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['same_lanr']) && full['same_lanr']) {
									return '** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['same_bsnr']) && full['same_bsnr']) {
									return '*** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['same_account_id']) && full['same_account_id']) {
									return '**** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['developer_license']) && full['developer_license']) {
									return '***** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['voucher_code']) && full['voucher_code'].length) {
									return '****** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['no_usage']) && full['no_usage']) {
									return '******* ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['free_of_charge']) && full['free_of_charge']) {
									return '******** ' + utils.getLocaleNumberFromString(data, 2);
								}
								else if (!utils.isUndefined(full['already_accounted']) && full['already_accounted']) {
									return '********* ' + utils.getLocaleNumberFromString(data, 2);
								}
								return utils.getLocaleNumberFromString(data, 2);
							}
						},
						{
							data: 'error',
							targets: [13],
							visible: false
						}
					];
				}
			}
		} else if (element[0].id === "table_audit_trail") {
			columnDefinitions = [
				{
					targets: 0,
					data: "id",
					visible: false,
					searchable: false
				},
				{
					targets: 1,
					data: "type"
				},
				{
					targets: 2,
					data: "project_abbreviation"
				},
				{
					targets: 3,
					data: "medical_practice_name"
				},
				{
					targets: 4,
					data: "database_table"
				},
				{
					targets: 5,
					data: "column"
				},
				{
					targets: 6,
					data: "old_value"
				},
				{
					targets: 7,
					data: "new_value"
				},
				{
					targets: 8,
					data: "updated_at",
					render: function (data, type, full, meta) {
						if (type === 'display' || type === 'filter') {
							return utils.dateToLocaleTimeString(data, false);
						}
						return utils.dateToTimeString(data);
					}
				},
				{
					targets: 9,
					data: "user"
				}
			];
		}

		$(this).on('processing.dt', function (e, settings, processing) {
			if (processing) {
				App.blockUI({
					target: 'body',
					animate: true
				});
			} else {
				App.unblockUI('body');
			}
		}).dataTable({
			processing: true,
			serverSide: false,
			paging: true,
			sort: sort,
			scrollY: scroll,
			scroller: {
				loadingIndicator: true
			},
			info: true,
			autoWidth: false,
			deferRender: true,
			pageLength: parseInt($(this)[0].getAttribute('data-table-page-length')),
			order: [[parseInt($(this)[0].getAttribute('data-table-default-order-column')), orderType]],
			language: {
				zeroRecords: zeroRecordsText,
				processing: '',
				emptyTable: emptyTableText
			},
			dom: dom,
			data: data,
			columnDefs: columnDefinitions,
			drawCallback: function (settings) {
				setPaginateButtons($(this), settings, false);
			},
			rowCallback: function (row, data, displayIndex) {
				row.id = data[0];

				if (row.id == $('#content-detail').find('.tt-selected-id').val()) {
					$(row).addClass('active');
				}
				if (element[0].id === 'table_account_draw_up') {
					row.id = data['id'];
					if (data['error']) {
						$(row).addClass('danger');
					}
					$($('td', row)[0]).addClass('text-align-right').addClass('padding-right-15');
					$('td:last', row).addClass('text-align-right').addClass('padding-right-15');

					if ((!utils.isUndefined(data['developer_license']) && data['developer_license']) || (!utils.isUndefined(data['voucher_code']) && data['voucher_code'].length) || (!utils.isUndefined(data['no_usage']) && data['no_usage'])
						|| (!utils.isUndefined(data['same_bsnr']) && data['same_bsnr']) || (!utils.isUndefined(data['same_lanr']) && data['same_lanr']) || (!utils.isUndefined(data['same_professional_group']) && data['same_professional_group'])
						|| (!utils.isUndefined(data['same_account_id']) && data['same_account_id']) || (!utils.isUndefined(data['free_of_charge']) && data['free_of_charge']) || (!utils.isUndefined(data['already_accounted']) && data['already_accounted']))
					{
						$('td', row).addClass('inactive');
					}
					$(row).find('[type="checkbox"]').prop('checked', data['selection']);
				} else if (element[0].id === 'table_audit_trail') {
					if (data['type'] === 'CREATED') {
						$(row).addClass('tt-created');
					} else if (data['type'] === 'DELETED') {
						$(row).addClass('tt-deleted');
					}
					$('td:nth-child(6)', row).addClass('text-align-right').addClass('audit-trail-column');
					$('td:nth-child(7)', row).addClass('text-align-right').addClass('audit-trail-column');
				}
			},
			initComplete: function (settings, json) {

				if (element[0].id === 'table_account_draw_up') {
					loadAccountingList();
				}
				$(this).addClass("datatable-container");
			}
		});

	});

	initializeSelect2($(element).find('.tt-select2:not(.select2-container)'));

	validator.setValidationToForms(element);

	$('.scroller').each(function () {
		if ($(this).attr("data-initialized")) {
			return; // exit
		}

		var height;

		if ($(this).attr("data-height")) {
			height = $(this).attr("data-height");
		} else {
			height = $(this).css('height');
		}

		$(this).slimScroll({
			allowPageScroll: true, // allow page scroll when the element scroll is ended
			size: '7px',
			color: ($(this).attr("data-handle-color") ? $(this).attr("data-handle-color") : '#bbb'),
			wrapperClass: ($(this).attr("data-wrapper-class") ? $(this).attr("data-wrapper-class") : 'slimScrollDiv'),
			railColor: ($(this).attr("data-rail-color") ? $(this).attr("data-rail-color") : '#eaeaea'),
			position: 'right',
			height: height,
			alwaysVisible: ($(this).attr("data-always-visible") == "1" ? true : false),
			railVisible: ($(this).attr("data-rail-visible") == "1" ? true : false),
			disableFadeOut: true
		});

		$(this).attr("data-initialized", "1");
	});

	$('.cubeportfolio:not(.cubeportfolio-container)').each(function () {
		$(this).cubeportfolio({

			closeButtonTitle: trans('extrax2-webadmin.close_report'),
			nextButtonTitle: trans('extrax2-webadmin.next_report'),
			prevButtonTitle: trans('extrax2-webadmin.prev_report'),
			singlePageSpinAround: false,
			singlePageCounter: '<div class="cbp-popup-singlePage-counter">{{current}} ' + trans('extrax2-webadmin.of') + ' {{total}}</div>',
			singlePageCallback: function (url, item) {
				var currentObject = this;

				ajax.ajaxCall($(item).data().href, 'GET', null, false, function (data) {
					currentObject.updateSinglePage(data);
					utils.setFormatValues($('.portfolio-content'));
					$('.cbp-next-label').text($('#next-report-date').text());
					$('.cbp-prev-label').text($('#prev-report-date').text());
					initializeElements($('.portfolio-content'));
				});
			}
		});

		$(this).addClass("cubeportfolio-container");
	});

	$(element).find('.tt-check-changes-form').each(function () {
		$(this).areYouSure({'silent': true});
	});

	$(element).find('.tt-pulsate-regular').each(function () {
		$(this).pulsate({
			color: '#e35b5a',
			glow: true,
			speed: 1000,
			pause: 1500,
			reach: 10
		});
	});
}

function setPaginateButtons(oTable, oSettings, setPageButtons) {
	if (oSettings !== null) {
		if (oSettings._iDisplayStart + oSettings._iDisplayLength >= oSettings.fnRecordsDisplay() || oSettings.fnRecordsTotal() <= oSettings._iDisplayLength) {
			oTable.parents('.tt-content-datatable').find('.tt-datatable-next').addClass('disabled');
			oTable.parents('.tt-content-datatable').find('.tt-datatable-next').prop('disabled', 'disabled');
		} else {
			oTable.parents('.tt-content-datatable').find('.tt-datatable-next').removeClass('disabled');
			oTable.parents('.tt-content-datatable').find('.tt-datatable-next').removeAttr('disabled');
		}
		if (setPageButtons) {
			$('#' + oTable.attr('id') + '_paginate').addClass('hide');
			$(oTable.parents('.tt-content-datatable').find('.tt-datatable-next')[0]).parent().find('.tt-button-paginate').remove();
			if ($('#' + oTable.attr('id') + '_paginate').find('li').length > 3) {
				jQuery.each($('#' + oTable.attr('id') + '_paginate').find('li'), function (i, button) {
					if ($(button).hasClass('previous') || $(button).hasClass('next')) {
						return;
					}
					var additionalClass = '';
					if ($(button).hasClass('disabled')) {
						additionalClass = ' disabled';
					}
					if ($(button).hasClass('active')) {
						additionalClass += ' active';
					}
					oTable.parents('.tt-content-datatable').find('.tt-datatable-next').before(
						'<button class="btn btn-default tt-button-paginate' + additionalClass + '" data-page="' + $(button).text() + '">' +
						$(button).text() +
						'</button>'
					);
				});
			}
		}
		if (oSettings._iDisplayStart == 0) {
			oTable.parents('.tt-content-datatable').find('.tt-datatable-previous').addClass('disabled');
			oTable.parents('.tt-content-datatable').find('.tt-datatable-previous').prop('disabled', 'disabled');
		} else {
			oTable.parents('.tt-content-datatable').find('.tt-datatable-previous').removeClass('disabled');
			oTable.parents('.tt-content-datatable').find('.tt-datatable-previous').removeAttr('disabled');
		}
	}
}

function initializeDatepicker(elements) {

	elements.each(function () {

		var dataDateFormat = $(this).data('dateformat') || 'full';

		if (dataDateFormat === 'full') {
			dataDateFormat = utils.getLocaleDateFormat();
		}
		dataDateFormat = utils.getMomentFormat(dataDateFormat);
		$(this).mask('?' + utils.getLocaleDateFormatMask(dataDateFormat), { placeholder: '_' });

		$(this).data('format', dataDateFormat);
		var picker = new Pikaday({
			field: $(this)[0],
			format: dataDateFormat,
			firstDay: 1,
			yearRange: 20,
			i18n: {
				previousMonth : trans('extrax2-webadmin.previous_month'),
				nextMonth     : trans('extrax2-webadmin.next_month'),
				months        : [trans('extrax2-webadmin.january'),trans('extrax2-webadmin.february'),trans('extrax2-webadmin.march'),trans('extrax2-webadmin.april'),trans('extrax2-webadmin.may'),trans('extrax2-webadmin.june'),trans('extrax2-webadmin.july'),trans('extrax2-webadmin.august'),trans('extrax2-webadmin.september'),trans('extrax2-webadmin.october'),trans('extrax2-webadmin.november'),trans('extrax2-webadmin.december')],
				weekdays      : [trans('extrax2-webadmin.sunday'),trans('extrax2-webadmin.monday'),trans('extrax2-webadmin.tuesday'),trans('extrax2-webadmin.wednesday'),trans('extrax2-webadmin.thursday'),trans('extrax2-webadmin.friday'),trans('extrax2-webadmin.saturday')],
				weekdaysShort : [trans('extrax2-webadmin.sunday_short'),trans('extrax2-webadmin.monday_short'),trans('extrax2-webadmin.tuesday_short'),trans('extrax2-webadmin.wednesday_short'),trans('extrax2-webadmin.thursday_short'),trans('extrax2-webadmin.friday_short'),trans('extrax2-webadmin.saturday_short')]
			},
			onClose: function (e) {

				utils.blurDatepicker(this._o.field);
			},
			onOpen: function (e) {

				if ($(this._o.field).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') === '') {
					this.setDate(moment().toDate());
					$(this._o.field).val('');
				}
			}
		});

		$(this).data('picker', picker);

		var initValue = $(this).data().initValue;
		if (!utils.isUndefined(initValue) && initValue !== '') {
			if (initValue !== 'not_collected' && initValue !== 'unknown' && initValue !== 'continuing' && initValue !== 'unlimited') {
				picker.setDate(utils.stringToDate(initValue));
			} else {
				picker.setDate(null);
				$(this).parents('.input-group').find('input').val(trans('extrax2-webadmin.' + initValue));
			}
		} else {
			picker.setDate(null);
		}

		$(this).addClass("datepicker-container");
	});
}

function initializeSelect2(elements) {

	elements.each(function () {

		if ($(this).hasClass('tt-select-ajax')) {

			var placeHolderString = Lang.get('extrax2-webadmin.no_selection');
			var attributePlaceholder = $(this).attr('data-select2-placeholder');
			var multiple = false;
			var attributeMultiple = $(this).attr('multiple');
			var url = $(this).attr('data-select2-url');
			var attributeDisabled = $(this).attr('disabled');
			var disabled = false;

			if (!utils.isUndefined(attributePlaceholder) && attributePlaceholder !== '') {
				placeHolderString = Lang.get('extrax2-webadmin.' + attributePlaceholder);
			}
			if (!utils.isUndefined(attributeMultiple) && attributeMultiple !== '') {
				multiple = attributeMultiple;
			}
			if (!utils.isUndefined(attributeDisabled) && attributeDisabled === 'disabled') {
				disabled = true;
			}

			$(this).select2({
				placeholder: placeHolderString,
				allowClear: true,
				multiple: multiple,
				disabled: disabled,
				minimumInputLength: 2,
				ajax: {
					url: url,
					dataType: 'json',
					delay: 250,
					data: function (params) { // page is the one-based page number tracked by Select2
						return {
							search_term: params.term, //search term
							page: params.page // page number
						};
					},
					processResults: function (data, params) {

						return { results: data };
					}
				},
				language: {
					noResults: function () {
						return Lang.get('extrax2-webadmin.no_data_found');
					},
					searching: function () {
						return Lang.get('extrax2-webadmin.searching');
					},
					inputTooShort: function (args) {
						return Lang.get('extrax2-webadmin.input_too_short_string', {'minLength': args.minimum});
					}
				},
				formatResult: validator.format,
				formatSelection: validator.format
			});

		} else {
			var placeHolderString = Lang.get('extrax2-webadmin.no_selection');
			var attributePlaceholder = $(this).attr('data-select2-placeholder');
			var attributeData = $(this).attr('data-select2-data');
			var data = null;
			var attributeMultiple = $(this).attr('data-select2-multiple');
			var multiple = false;
			var attributeTags = $(this).attr('data-select2-tags');
			var tags = false;
			var attributeDisabled = $(this).attr('disabled');
			var disabled = false;

			if (!utils.isUndefined(attributePlaceholder) && attributePlaceholder !== '') {
				placeHolderString = Lang.get('extrax2-webadmin.' + attributePlaceholder);
			}
			if (!utils.isUndefined(attributeData) && attributeData !== '') {
				data = jQuery.parseJSON(attributeData);
			}
			if (!utils.isUndefined(attributeMultiple) && attributeMultiple !== '') {
				multiple = attributeMultiple;
			}
			if (!utils.isUndefined(attributeTags) && attributeTags !== '') {
				tags = attributeTags;
			}
			if (!utils.isUndefined(attributeDisabled) && attributeDisabled === 'disabled') {
				disabled = true;
			}

			if (data == null) {
				$(this).select2({
					placeholder: placeHolderString,
					allowClear: true,
					tags: tags,
					disabled: disabled,
					language: {
						noResults: function () {
							return Lang.get('extrax2-webadmin.no_data_found');
						},
						searching: function () {
							return Lang.get('extrax2-webadmin.searching');
						},
						inputTooShort: function (args) {
							return Lang.get('extrax2-webadmin.input_too_short_string', {'minLength': args.minimum});
						}
					},
					formatResult: validator.format,
					formatSelection: validator.format
				});
			} else {
				$(this).select2({
					placeholder: placeHolderString,
					multiple: multiple,
					data: data,
					tags: tags,
					disabled: disabled,
					allowClear: true,
					language: {
						noResults: function () {
							return Lang.get('extrax2-webadmin.no_data_found');
						},
						searching: function () {
							return Lang.get('extrax2-webadmin.searching');
						},
						inputTooShort: function (args) {
							return Lang.get('extrax2-webadmin.input_too_short_string', {'minLength': args.minimum});
						}
					},
					formatResult: validator.format,
					formatSelection: validator.format
				});
			}
		}

		$(this).addClass("select2-container");
	});
}

function initializeSummernote(elements) {

	elements.each(function () {

		$(this).summernote({
			height: '200',
			lang: 'de-DE',
			disableLinkTarget: true,
			toolbar: [
				['style', ['style']],
				['font', ['bold', 'italic', 'underline', 'clear']],
				['fontsize', ['fontsize']],
				['color', ['color']],
				['para', ['ul', 'ol', 'paragraph']],
				['table', ['table']],
				['insert', ['link', 'picture']]
			],
			onChange: function (contents, $editable)
			{
				if ($(this).parents('.tt-content-detail').find('.tt-summernote-changes').val() !== 'changed') {
					$(this).parents('.tt-content-detail').find('.tt-summernote-changes').val("changed");
					$("#content-detail").find('form').trigger('checkform.areYouSure');
				}
			}
		});

		// Wert setzen
		var initValue = $(this).data().initValue;
		if (!utils.isUndefined(initValue) && initValue !== '') {
			$(this).code(initValue);
		}

		$(this).addClass("summernote-container");
		$(this).parent().find('.note-editor').addClass('note-frame');
	});
}

function loadAccountingList() {

	var tillVal = '';
	if ($('#till_date').length) {
		tillVal = jQuery($('#till_date')).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '');
		if (tillVal !== '') {
			var picker = $('#till_date').data('picker');
			tillVal = utils.dateToString(picker.getDate());
		}
	}

	ajax.ajaxCallDeferred($('#table_account_draw_up').data().tableUrl, 'GET', 'till_date=' + tillVal).done(function (data) {
		if (ajax.ajaxSucceeded(data)) {
			$('#table_account_draw_up').dataTable().api().clear().rows.add(data[0]).draw();
			var hasError = false;
			jQuery.each(data[0], function(index, row) {
				if (row['error']) {
					hasError = true;
					return false;
				}
			});
			if (hasError) {
				$('.error-message').removeClass('display-none');
			} else {
				$('.error-message').addClass('display-none');
			}
			$('.tt-total-amount').text(utils.numberToString(data[1], 2) + ' €');
		}
	});
}

module.exports.initializeElements = initializeElements;
module.exports.initializeDatepicker = initializeDatepicker;
module.exports.loadAccountingList = loadAccountingList;
